import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';

import { PublicParams } from '@core/modules/public/entities/public-params.entity';
import { PublicRouterService } from '@core/modules/public/services/public-router.service';
import { StorageService } from '@core/shared/services';
import { QUERY_OPERATING_INTENTION } from '@core/modules/auth/data/constants';
import { SchedulerStore } from '@data/stores';

const getInitialParam = (maps: Record<string, string>[]) => {
  const key = 'customer_operation';

  return maps.find((item) => key in item && !!item?.[key])?.[key] || '';
};

export const publicParamsResolver: ResolveFn<Promise<PublicParams>> = async (
  route,
  _,
) => {
  const publicRouter = inject(PublicRouterService);
  const storage = inject(StorageService);
  const store = inject(SchedulerStore);

  const { queryParams } = route;
  const storageQueryParam = await storage.getParam(
    QUERY_OPERATING_INTENTION,
    {},
  );

  await storage.clearParam(QUERY_OPERATING_INTENTION);

  const customerOperation = getInitialParam([queryParams, storageQueryParam]);
  store.setCustomerOperation(customerOperation);

  const params = PublicParams.fromJson({
    ...queryParams,
    customer_operation: customerOperation,
  });

  publicRouter.setQueryParams(params);

  return params;
};
